import { Component, Inject, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { GsnFileComponent } from 'app/sales-module/gsn/gsn-file/gsn-file.component';
import { ApprovalTimelineDialogComponent } from '../../../components/approval-timeline/approval-timeline-dialog.component';
import { ApprovalTimelineData } from '../../../components/approval-timeline/approval-timeline.component';
import { DocumentTracingModalComponent } from 'app/components/document-tracing-modal/document-tracing-modal.component';
import { MatSelect } from '@angular/material/select';
import { ReOpenService } from 'app/reopen.service';
import { CancelApprovalService } from 'app/cancel-approval.service';
import { UiPanelAction, UiPanelMode, UiApprovalStep } from 'app/shared/ui/models/ui-document-panel.model';
import { UiBadgeVariant } from 'app/shared/ui/models/ui-badge.model';
import { UiUnsavedChangesDialogComponent, UnsavedChangesResult } from 'app/shared/ui/document-panel/ui-unsaved-changes-dialog/ui-unsaved-changes-dialog.component';
import { UI_DOCUMENT_PANEL_BREADCRUMBS } from 'app/shared/ui/document-panel/document-panel.config';

@Component({
  selector: 'app-gsn-dialog',
  templateUrl: './gsn-dialog.component.html',
  styleUrls: ['./gsn-dialog.component.scss'],
  host: { class: 'ui-document-panel-host' },
})
export class GsnDialogComponent {
  so: any;
  so_data: any[] = [];
  gsn_no: any;
  date: any;
  maxDate: string = '';
  productList: any[] = [];
  // document_no: number = null;
  customer: any;
  customerdata: any;
  customerid: any;
  filteredQuotations = [];
  isUpdateMode: boolean = false;
  panelMode: UiPanelMode = 'create';
  enteredEditFromView = false;
  editSnapshot: string | null = null;
  user_id: any;
  is_short_close: boolean = false;
  readonly breadcrumb = UI_DOCUMENT_PANEL_BREADCRUMBS.gsn;
  selectedCustomerBranchName: string = '';
  selectedCustomerBranchId:any;
  so_ids: string = '';
  customer_branch:any;
  selectedCustomerBranch:any;
  customer_branch_details: any = null;
  section_data: any;
  section_id:any;
  branch_id:any;
  branch_data:any;
  profit_cost_id:any;
  profit_cost_data:any;
  branch_pc_data:any
  filteredBranchData:any;
  filteredPcCcData:any
  filteredSectionData:any;
  // pc_cc:string = '';
  image_data: any;
  uploadedFiles: any[] = [];
  fullhostname: string;
  grandTotal: number = 0;
  isView: boolean = false;
  today = new Date().toISOString().split('T')[0];
  customerSearch = '';
  customerOffset = 0;
  customerLimit = 100;
  customerHasMore = true;
  loadingCustomer = false;
  branchSearch = '';
  loadingBranch = false;
  branchOffset = 0;
  is_reverse: boolean = false;
  branchLimit = 100;
  branchHasMore = true;
  @ViewChild('customerSelect') customerSelect!: MatSelect;
  @ViewChild('branchSelect') branchSelect!: MatSelect;
  lumpsum_discount: number = 0;
  lumpsum_incentive: number = 0;
  manual_lumpsum: boolean = false;
  lumpsum_remark: string = '';
  constructor(
    private apiService: ApiService,
    public dialogRef: MatDialogRef<GsnDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialog: MatDialog,
    private reopenService: ReOpenService,
    private cancelApprovalService: CancelApprovalService,
  ) {
    const userString = localStorage.getItem('data');
    const user = JSON.parse(userString) || {};
    this.user_id = user?.id;
    if (this.data?.short_close !== undefined) {
      this.is_short_close = this.data.short_close === 1;
    }
    this.initPanelMode();
    if (this.data?.id) {
      this.fetchGsnProductList(this.data.id);
    }
  }

  ngOnInit(): void {
    const today = new Date();
    this.date = this.formatDate(today);
    this.maxDate = this.formatDate(today);
    this.customerData();
    this.fetchbranch();
    this.fetchPcCc();
    this.fetchSection();
    this.fullhostname = window.location.origin;
    if (this.panelMode === 'edit') {
      this.editSnapshot = this.captureEditSnapshot();
    }
  }
  formatDate(date: Date): string {
    return date.toISOString().split('T')[0];
  }
  fetchGsnProductList(GsnId): void {
    this.apiService.showGsnById(GsnId).subscribe(
      (response) => {
        if (this.data && (this.data.approval_status === undefined || this.data.approval_status === null)) {
        const header = Array.isArray(response.data) ? response.data[0] : response.data;
          const fetchedStatus = header?.approval_status ?? response?.approval_status ?? null;
          if (fetchedStatus !== undefined && fetchedStatus !== null) {
            this.data.approval_status = fetchedStatus;
          }
        }

        this.productList = response.data;
        console.log('product_listsss:', this.productList);
        if (response.data[0]?.short_close !== undefined) {
          this.is_short_close = response.data[0].short_close === 1;
        }
        this.productList.forEach((product: any) => {
          if (product.details) {
            product.details.forEach((detail: any) => {
              const formattedQty = Number(detail.send_qty.toFixed(3));
              const send_qty = detail.send_qty;
              detail.send_qty = detail.send_qty ? (formattedQty) : 0;
              detail.actual_qty = send_qty;
              detail.send_price = detail.send_price ? (detail.send_price).toFixed(2) : 0;
              detail.unit_price = detail.unit_price ? (detail.unit_price).toFixed(2) : 0;
              detail.price = detail.price ? (detail.price).toFixed(2) : 0;
              detail.discount_amount = Number(detail.discount_amount) || 0;
              detail.incentive_amount = Number(detail.incentive_amount) || 0;
              detail.net_adjustment_amount = Number(detail.net_adjustment_amount) || 0;
              detail.remark = detail.remark || '';
            });
          }
        });
        
        const header_amount = Number(response.data[0]?.lumpsum_amount) || 0;
        const header_type = response.data[0]?.amount_type;
        this.lumpsum_discount = (header_type == 1) ? header_amount : 0;
        this.lumpsum_incentive = (header_type == 2) ? header_amount : 0;
        this.lumpsum_remark = response.data[0]?.remark || '';
        
        
        this.date = this.productList[0].date,
          this.gsn_no = this.productList[0].gsn_no,
          // this.document_no = this.productList[0].doc_no,
          this.customer = this.productList[0].customer.id,
          this.getCustomerBranch(this.customer);
          this.selectedCustomerBranchName =  this.productList[0].customer_branch?.branch_name || '',
          this.selectedCustomerBranchId = this.productList[0].customer_branch_id??'';
          this.customer_branch = this.productList[0].customer_branch_id;
          this.customerBranchDetails(this.selectedCustomerBranchId);
          this.so_ids=this.productList[0]?.sales_order_id;
         // this.branch = this.productList[0]?.customer_branch_id;
          //this.so=this.productList[0]?.sales_order_id.split(',').map(Number);
          this.fetchso(this.customer,this.selectedCustomerBranchId);
          this.branch_id = this.productList[0]?.branch_id;
          // this.pc_cc = this.productList[0]?.profit_cost_id;
          this.profit_cost_id = this.productList[0]?.profit_cost_id?.split(',').map((id: string) => +id) || [];
          // this.section_id = this.productList[0].section.id;
          this.section_id = this.productList[0]?.section_id?.split(',').map((id: string) => +id) || [];
          //this.fetchProductList();
          if (response.uploaded_files && response.uploaded_files.length > 0) {
          this.uploadedFiles = response.uploaded_files.map((file: any) => ({
            ...file,
            preview: `${this.fullhostname}/api/storage/${file.image}`,
          }));
        } else {
          this.uploadedFiles = [];
        }     
          console.log('product_list:', this.productList);
          console.log('so ids:',  this.so_ids);
          //console.log('so:',  this.so);
          console.log('customer branch:',  this.selectedCustomerBranchName);
      },
      (error) => {
        console.error('Error fetching gsn products:', error);
        this.productList = [];
      }
    );
  }
  // customerData() {
  //   this.apiService.customerOfSo().subscribe(
  //     (response) => {
  //       const uniqueCustomers = new Map();
  //       response.forEach(customer => {
  //         if (!uniqueCustomers.has(customer.customer_id)) {
  //           uniqueCustomers.set(customer.customer_id, customer);
  //         }
  //       });
  
  //       this.customerdata = Array.from(uniqueCustomers.values());
  //       console.log('Filtered customerdata', this.customerdata);
  //     },
  //     (error) => {
  //       console.error('Error fetching data:', error);
  //     }
  //   );
  // }
  customerData(params?: {
  offset?: number;
  limit?: number;
  search?: string;
  type?: string;
}) {
  if (this.loadingCustomer) return;
  this.loadingCustomer = true;
  this.apiService.customerOfSo(params).subscribe(
    (response: any) => {
      if (!params || params.type !== 'lazyloading') {
        const uniqueCustomers = new Map();

        (response || []).forEach((customer: any) => {
          if (!uniqueCustomers.has(customer.customer_id)) {
            uniqueCustomers.set(customer.customer_id, customer);
          }
        });
        this.customerdata = Array.from(uniqueCustomers.values());
        this.loadingCustomer = false;
        return;
      }
      const data = response.data || response || [];

      this.customerdata = [...this.customerdata, ...data];
      if (data.length < (params.limit || this.customerLimit)) {
        this.customerHasMore = false;
      }
      this.customerOffset += data.length;
      this.loadingCustomer = false;
    },
    (error) => {
      this.loadingCustomer = false;
      console.error('Error fetching customer data:', error);
    }
  );
}
  getTotalSendQty(details: any[], type: string, levelNo: any ,so_id: number): number {
    if (!details) return 0;
    return details
      .filter((d) => d.item_service_type === type && d.level_no === levelNo && d?.gsn?.sales_order_id == so_id)
      .reduce((sum, d) => sum + parseFloat(d.send_qty), 0);
  }
  
  // getRemainingQty(detail: any): number {
  //   //return detail?.qty - this.getTotalSendQty(detail?.gsn_details, detail?.item_service_type, detail?.level_no,detail?.sales_order_id);
  //   const remainingQty = detail?.qty - this.getTotalSendQty(detail?.gsn_details, detail?.item_service_type, detail?.level_no, detail?.sales_order_id);
  //   return parseFloat(remainingQty.toFixed(2));
  // }
  parseNumber(value: any): number {
    return parseFloat(value) || 0;
  }
  fetchso(customer_id: any,customer_branch_id:any) {
    //this.productList = [];
    this.customerBranchDetails(customer_branch_id);
    this.so_data=[];
    this.customerid = customer_id;
    console.log('customer id ', this.customerid);
    if (!this.data?.id) {
    const selectedCustomer = this.customerdata.find(item => item.customer_id === customer_id);
    this.selectedCustomerBranchName = selectedCustomer ? selectedCustomer.customer_branch_name : '';
    this.selectedCustomerBranchId = selectedCustomer ? selectedCustomer.customer_branch_id : '';
    }
    console.log('customer id ', this.customerid)
    const postData = {
      customer_id: this.customerid,
      customer_branch_id:customer_branch_id
    };

    this.apiService.getSales(postData).subscribe(
      (response) => {
        if (!response || response.length === 0) {
          console.log('No sales orders found.');
          return;
        }
        console.log('so_data',this.so_data);
        // this.so_data = response.filter((item: any) => {
        //   return item.is_approved == 1 && item.short_close !== 1;
        // });
        this.so_data = response;
        if (this.data?.id) {
          this.setSelectedso(this.so_ids);
        }
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }

  setSelectedso(soIds: string) {
    // console.log('so_ids',soIds)
    // const selectedIds = soIds.split(',').map((id) => +id);
    // console.log('so_data',this.so_data);
    // this.so = this.so_data.filter((item) => selectedIds.includes(item.id));
    // console.log('so',this.so);
    console.log('so_ids', soIds);
    this.so = soIds.split(',').map(id => +id); // Store only IDs, not objects
    console.log('so', this.so);   
    this.onSoChange(this.so);
  }
  fetchgsnNo() {
    // this.apiService.getGsnNo().subscribe(
    //   (response) => {
    //     this.gsn_no = response.gsn_no;
    //     console.log('gsn_no :', this.gsn_no);
    //   },
    //   (error) => {
    //     console.error('Error fetching data:', error);
    //   }
    // );
  }

  fetchProductList(): void {
  //  const sectionId: number[] = this.section_id ? [parseInt(this.section_id, 10)] : [];
    const sectionIds: number[] = this.section_id
      ? (Array.isArray(this.section_id) ? this.section_id.map((id: any) => parseInt(id, 10)) : [parseInt(this.section_id, 10)])
      : [];

    const profitCostIds: number[] = this.profit_cost_id
      ? (Array.isArray(this.profit_cost_id) ? this.profit_cost_id.map((id: any) => parseInt(id, 10)) : [parseInt(this.profit_cost_id, 10)])
      : [];
    this.apiService.getProductsBySo(this.so,sectionIds,profitCostIds).subscribe(
      (response) => {
        this.productList = response.data;
        console.log('Fetched so Product List:', this.productList);
          this.productList.forEach((product: any) => {
            if (product.so_details) {
              product.so_details.forEach((detail: any) => {
                detail.qty = detail.qty ? (detail.qty).toFixed(3) : 0;
                detail.unit_price = detail.unit_price ? (detail.unit_price).toFixed(2) : 0;
                detail.price = detail.price ? (detail.price).toFixed(2) : 0;
                // detail.discount_amount = 0;
                // detail.incentive_amount = 0;
              });
            }
          });
      },
      (error) => {
        console.error('Error fetching so products:', error);
        this.productList = [];
      }
    );
  }

  get isInputDisabled(): boolean {
    return this.panelMode === 'view' || this.is_reverse;
  }

  private initPanelMode(): void {
    if (this.data?.type === 'View') {
      this.panelMode = 'view';
      this.isView = true;
      this.isUpdateMode = true;
    } else if (this.data?.type === 'Update') {
      this.panelMode = 'edit';
      this.isView = false;
      this.isUpdateMode = true;
    } else {
      this.panelMode = 'create';
      this.isView = false;
      this.isUpdateMode = false;
    }
  }

  get panelTitle(): string {
    if (this.is_reverse) return 'Reverse GSSN';
    switch (this.panelMode) {
      case 'create': return 'Create GSSN';
      case 'edit': return 'Edit GSSN';
      case 'view': return 'View GSSN';
      default: return 'GSSN';
    }
  }

  get statusLabel(): string {
    if (!this.data?.id) return 'Draft';
    return this.data.approval_status || 'Open';
  }

  get statusVariant(): UiBadgeVariant {
    const status = this.data?.approval_status;
    if (!this.data?.id || status == null || status === 'Open') return 'default';
    if (status === 'Approved') return 'approved';
    if (status === 'Pending') return 'pending';
    if (status === 'Rejected') return 'rejected';
    return 'default';
  }

  get approvalSteps(): UiApprovalStep[] {
    const status = this.data?.approval_status;
    const steps: UiApprovalStep[] = [
      { id: 'draft', label: 'Draft', icon: 'edit_note', state: 'upcoming' },
      { id: 'pending', label: 'Pending Approval', icon: 'schedule', state: 'upcoming' },
      { id: 'approved', label: 'Approved', icon: 'check_circle', state: 'upcoming' },
    ];
    if (!this.data?.id) { steps[0].state = 'active'; return steps; }
    if (status == null || status === 'Open') steps[0].state = 'active';
    else if (status === 'Pending') { steps[0].state = 'completed'; steps[1].state = 'active'; }
    else if (status === 'Approved') { steps[0].state = 'completed'; steps[1].state = 'completed'; steps[2].state = 'completed'; }
    else if (status === 'Rejected') { steps[0].state = 'completed'; steps[1].state = 'rejected'; }
    return steps;
  }

  canEdit(): boolean {
    const status = this.data?.approval_status;
    return status == null || status === 'Open' || status === 'Rejected';
  }

  enterEditMode(): void {
    if (!this.canEdit()) return;
     if (!confirm('Do you want to edit this record?')) {
      return;
    }
    this.enteredEditFromView = true;
    this.panelMode = 'edit';
    this.isView = false;
    this.isUpdateMode = true;
    if (this.data) this.data.type = 'Update';
    this.editSnapshot = this.captureEditSnapshot();
  }

  enterViewMode(): void {
    this.panelMode = 'view';
    this.isView = true;
    this.isUpdateMode = true;
    this.enteredEditFromView = false;
    this.editSnapshot = null;
    if (this.data) this.data.type = 'View';
  }

  private captureEditSnapshot(): string {
    return JSON.stringify({
      customer: this.customer,
      customer_branch: this.customer_branch,
      so: this.so,
      branch_id: this.branch_id,
      profit_cost_id: this.profit_cost_id,
      section_id: this.section_id,
      date: this.date,
      productList: this.productList,
      lumpsum_discount: this.lumpsum_discount,
      lumpsum_incentive: this.lumpsum_incentive,
      lumpsum_remark: this.lumpsum_remark,
      uploadedFiles: this.uploadedFiles,
    });
  }

  hasUnsavedChanges(): boolean {
    if (this.panelMode !== 'edit' || !this.editSnapshot) return false;
    return this.captureEditSnapshot() !== this.editSnapshot;
  }

  private restoreFromSnapshot(): void {
    if (!this.editSnapshot) return;
    const s = JSON.parse(this.editSnapshot);
    Object.assign(this, {
      customer: s.customer,
      customer_branch: s.customer_branch,
      so: s.so,
      branch_id: s.branch_id,
      profit_cost_id: s.profit_cost_id,
      section_id: s.section_id,
      date: s.date,
      productList: s.productList,
      lumpsum_discount: s.lumpsum_discount,
      lumpsum_incentive: s.lumpsum_incentive,
      lumpsum_remark: s.lumpsum_remark,
      uploadedFiles: s.uploadedFiles,
    });
  }

  onClose(): void { this.handleExitIntent('close'); }

  onCancel(): void {
    if (this.panelMode === 'edit' && this.enteredEditFromView) {
      this.handleExitIntent('view');
      return;
    }
    this.handleExitIntent('close');
  }

  private handleExitIntent(intent: 'close' | 'view'): void {
    if (this.panelMode === 'edit' && this.hasUnsavedChanges()) {
      this.promptUnsavedChanges(intent);
      return;
    }
    this.executeExitIntent(intent);
  }

  private executeExitIntent(intent: 'close' | 'view'): void {
    if (intent === 'view') this.enterViewMode();
    else this.dialogRef.close();
  }

  private promptUnsavedChanges(intent: 'close' | 'view'): void {
    const promptRef = this.dialog.open(UiUnsavedChangesDialogComponent, {
      width: '440px', disableClose: true, panelClass: 'ui-unsaved-changes-dialog',
    });
    promptRef.afterClosed().subscribe((result: UnsavedChangesResult | undefined) => {
      if (!result || result === 'cancel') return;
      if (result === 'discard') { this.restoreFromSnapshot(); this.executeExitIntent(intent); return; }
      if (result === 'save') this.save(intent);
    });
  }

  get footerPrimaryActions(): UiPanelAction[] {
    if (this.panelMode === 'view') {
      return this.canEdit() ? [{ id: 'edit', label: 'Edit', icon: 'edit', variant: 'primary', visible: true }] : [];
    }
    return [
      { id: 'save', label: 'Save', icon: 'save', variant: 'success', visible: true },
      { id: 'send-approval', label: 'Send for Approval', icon: 'send', variant: 'primary',
        visible: !!this.data?.id && this.canEdit() },
    ];
  }

  get footerSecondaryActions(): UiPanelAction[] {
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', variant: 'outline',
        visible: !!this.data?.id && this.panelMode !== 'view' },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline', variant: 'outline',
        visible: !!this.data?.id && ['Pending','Rejected','Approved'].includes(this.data.approval_status) && this.panelMode !== 'view' },
      { id: 'cancel', label: this.panelMode === 'view' ? 'Close' : 'Cancel', icon: 'close', variant: 'ghost', visible: true },
    ];
  }

  get footerDestructiveAction(): UiPanelAction | null {
 if (this.panelMode !== 'view' || this.user_id !== 1 || !this.data?.id) {
      return null;
    }
    const status = this.data.approval_status;
    if (status === 'Approved' || status === 'Pending' || status === 'pending') {
      return null;
    }    return { id: 'delete', label: 'Delete', icon: 'delete', variant: 'danger', visible: true };
  }

  get footerOverflowActions(): UiPanelAction[] {
    if (this.panelMode !== 'view' || !this.data?.id) return [];
    const status = this.data.approval_status;
    return [
      { id: 'tracing', label: 'Document Tracing', icon: 'account_tree', visible: true },
      { id: 'timeline', label: 'Approval Timeline', icon: 'timeline',
        visible: ['Pending','Rejected','Approved'].includes(status) },
      { id: 'short-close', label: 'Short Close', icon: 'block', visible: this.data?.approval_status === 'Approved' && !this.is_short_close },
      { id: 'reopen', label: 'Reopen', icon: 'replay', visible: status === 'Approved' && this.user_id === 1 },
      { id: 'cancel-approval', label: 'Cancel Approval', icon: 'cancel', visible: status === 'Pending' && this.user_id === 1 },
      { id: 'reverse', label: 'Reverse', icon: 'undo', visible: status === 'Approved' && !this.is_reverse },
    ];
  }

  onFooterAction(actionId: string): void {
    switch (actionId) {
      case 'save': this.save(); break;
      case 'send-approval': this.sendForApprove(); break;
      case 'tracing': if (this.data?.id) this.viewRelatedDocuments(this.data.id); break;
      case 'timeline': this.showApprovalTimeline(); break;
      case 'edit': this.enterEditMode(); break;
      case 'delete': this.deleteGsn(); break;
      case 'reopen': this.onReopen(); break;
      case 'cancel-approval': this.onCancelApproval(); break;
      case 'cancel': this.onCancel(); break;
      case 'short-close': this.shortCloseGsn(); break;
      case 'reverse':   this.openReverseMode(); break;
    }
  }

  deleteGsn(): void {
      if (!this.data?.id) {
      return;
    }
    const skuIds = this.productList
      ?.flatMap(p => p.details || p.po_details || [p])
      .map((d: any) => d.sku_id?.id || d.sku_id)
      .filter(Boolean) || [];

    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'Gsn',
      sku_id: skuIds.length > 0 ? skuIds : undefined,
      type: 'delete'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert('Next document already exists. Deletion is not allowed.');
      } else {
        if (confirm('Are you sure you want to delete this Gsn?')) {
           const deleteData = {
          doc_type: 'Gsn',  // ← Backend needs this
          doc_id: this.data.id,  // ← Backend needs this
          type: 'delete'  // ← Backend needs this
        };
          this.apiService.deleteGsn(this.data.id,deleteData ).subscribe(
            (response) => {
              alert(response.message);
              this.dialogRef.close({ id: this.data.id, action: 'delete' });
            },
            (error) => {
              console.error('Error deleting Gsn:', error.error?.message);
              alert(error.error?.message);
            }
          );
        }
      }
    });
  }

  onReopen(): void {
    if (!this.data?.id) return;
     const status = this.data?.approval_status;
     if (!confirm('Do you want to reopen this document?')) return;
    this.reopenService.reopen(this.data.id, 'Gsn', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  onCancelApproval(): void {
    if (!this.data?.id) return;
    this.cancelApprovalService.cancelApproval(this.data.id, 'Gsn', () => {
      this.data.approval_status = 'Open';
      this.enterViewMode();
    });
  }

  shortCloseGsn(): void {
    if (!this.data?.id) return;
    this.apiService.checkNextDocument({
      doc_id: this.data.id,
      model: 'Gsn',
      type: 'short_close'
    }).subscribe((res: any) => {
      if (res.status === false) {
        alert(res.message);
        return;
      }
      if (confirm('Do you want to short close this document?')) {
        const payload = { gsn_id: this.data.id, type: 'short_close' };
        this.apiService.gsnShortClose(payload).subscribe(
          (response) => { alert(response.message); this.dialogRef.close({ id: this.data.id, action: 'short_close' }); },
          (error) => alert(error.error?.message)
        );
      }
    });
  }
  
 openReverseMode(): void {
  if (!this.data?.id) return;
  if (!confirm('Do you want to reverse this GSSN?')) return;
  this.is_reverse = true;
  this.panelMode = 'edit';
  this.isView = false;
  this.data.type = 'reverse';

  // this.productList.forEach((product: any) => {
  //   product.details.forEach((detail: any) => {
  //     detail.send_qty = detail.gsn_remaining_qty || 0;
  //   });
  // });

  this.editSnapshot = this.captureEditSnapshot();
}  

  save(exitAfterSave: 'close' | 'view' = 'view'): void {
     if (!this.customer || !this.customer_branch || this.so.length === 0 || !this.branch_id || !this.profit_cost_id || !this.section_id || !this.date) {
      alert('Please fill in all required fields.');
      return;
    }
    if (!this.data?.id) {
      const selectedSo = this.so_data?.find((item: any) => Number(item.id) === Number(this.so));
      const soNo = selectedSo?.so_no ?? this.so;
      let hasAnySendQty = false;
      
      for (const product of this.productList) {
        if (!product.so_details || product.so_details.length === 0) {
          alert(`No details found in this SO (${soNo})`);
          return;
        }

        // let allZero = true;
        for (const detail of product.so_details) {
          const itemName =
            detail.item_service_type === 'SKU'
              ? detail.stock_keeping?.sku_name
              : detail.service?.service_name;
          const sendQty = Number(detail.send_qty) || 0;
          const pendingQty =detail.remaining_qty;
          if (sendQty > pendingQty) {
            alert(
              `Send Quantity (${sendQty}) cannot be greater than Pending Quantity (${pendingQty}) for ${itemName}`
            );
            return;
          }
          if (sendQty > 0) {
            hasAnySendQty = true;
            // Validate required fields from SO
            const skuId = detail.item_service_type === 'SKU' ? detail?.stock_keeping?.id : detail?.service?.id;
            if (!skuId) {
              alert(`Item/Service ID is missing for "${itemName}" (Product Service No: ${detail.product_service_no || 'N/A'}). This item may have been deleted or is not properly linked in the Sales Order. Please check the Sales Order.`);
              return;
            }
            if (!detail.unit?.id) {
              alert(`UOM (Unit of Measurement) is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.section_id) {
              alert(`Section is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.profit_cost_id) {
              alert(`Profit/Cost Center is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.sales_order_id) {
              alert(`Sales Order ID is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.level_no) {
              alert(`Level No is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }

            if (!detail.gsn_start_date && !detail.gsn_end_date) {
              alert(
                `Start Date and End Date are mandatory for ${itemName}`
              );
              return;
            }
          }
        }
      }
      if (!hasAnySendQty) {
        alert(`Please enter Send Quantity for at least one item`);
        return;
      }
    } else {
      let hasAnySendQty = false;

      for (const product of this.productList) {
        for (const detail of product.details) {
          const itemName =
            detail.item_service_type === 'SKU'
              ? detail.sku?.sku_name
              : detail.service?.service_name;
          const sendQty = Number(detail.send_qty) || 0;
          const pendingQty = this.getInitialTotal(detail);
          console.log('pendingQty', pendingQty);
          if (sendQty > pendingQty) {
            alert(
              `Send Quantity (${sendQty}) cannot be greater than Pending Quantity (${pendingQty}) for ${itemName}`
            );
            return;
          }
          if (sendQty > 0) {
            hasAnySendQty = true;
           // Validate required fields
            const skuId = detail.item_service_type === 'SKU' ? detail?.sku?.id : detail?.service?.id;
            if (!skuId) {
              alert(`Item/Service ID is missing for "${itemName}" (Product Service No: ${detail.product_service_no || 'N/A'}). This item may have been deleted or is not properly linked. Please check the Sales Order.`);
              return;
            }
            if (!detail.unit?.id) {
              alert(`UOM (Unit of Measurement) is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.section_id) {
              alert(`Section is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.profit_cost_id) {
              alert(`Profit/Cost Center is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }
            if (!detail.sales_order_id) {
              alert(`Sales Order ID is missing for "${itemName}". Please check the Sales Order.`);
              return;
            }

            if (!detail.start_date && !detail.end_date) {
              alert(
                `Start Date and End Date are mandatory for ${itemName}`
              );
              return;
            }
          }
        }
      }
      if (!hasAnySendQty) {
        alert(`Please enter Send Quantity for at least one item`);
        return;
      }
    }
    const postData = {
      so_id: this.data?.id || this.so,
      gsn_no: this.gsn_no || null,
      date: this.date,
      // doc_no: this.document_no,
      customer_id: this.customer,
      customer_branch_id : this.customer_branch,
      section_id: this.section_id,
      profit_cost_id: this.profit_cost_id.map(Number),
      branch_id: this.branch_id,
      uploaded_files: this.uploadedFiles,
      lumpsum_amount: this.getFinalHeaderAmount(),
      amount_type: this.getGreaterAdjustmentType(),
      remark: this.lumpsum_remark,
      document_type: 'Gsn',
      type:this.data?.type,
      products: this.productList.map(product => {
        const soDetails = product.so_details
          ? product.so_details
            .filter(detail => detail.remaining_qty > 0)
            .map(detail => ({
              sku_id: detail?.item_service_type === 'SKU' ? detail?.stock_keeping?.id : detail?.service?.id,
              item_service_type:detail?.item_service_type,
              description: detail.description || '',
              quantity: detail.qty || 0,
              hsn_no: detail.hsn_no || '',
              unit_id: detail.unit?.id || null,
              so_start_date: detail.start_date || null,
              so_end_date: detail.end_date || null,
              price: detail.price || 0,
              send_qty: detail.actual_qty ?? 0,
              delivery_date: product.delivery_deadline_date || null,
              store_id: detail.store_id,
              unit_price: detail.unit_price,
              level_no: detail.level_no,
              section_id:detail.section_id,
              start_date: detail.gsn_start_date || null,
              end_date: detail.gsn_end_date || null,
              send_price: detail.gsn_total_price ?? 0,
              sales_order_id:detail.sales_order_id,
              line_document_no:detail.line_document_no,
              product_service_no:detail.product_service_no,
              profit_cost_id:detail.profit_cost_id,
              discount_amount: detail.discount_amount || 0,
              incentive_amount: detail.incentive_amount || 0,
              net_adjustment_amount: this.getLineAdjustmentPrice(detail),
              remark: detail.remark || '',
              reverse_qty: detail.reverse_qty ?? null,
            }))
          : [];
        const productDetails = Array.isArray(product.details)
          ? product.details.map(detail => ({
            sku_id: detail?.item_service_type === 'SKU' ? detail?.sku?.id : detail?.service?.id,
            description: detail.description || '',
            quantity: detail.qty || 0,
            hsn_no: detail.hsn_no || '',
            unit_id: detail.unit?.id || null,
            so_start_date: detail.so_start_date || null,
            so_end_date: detail.so_end_date || null,
            price: detail.price || 0,
            send_qty: detail.send_qty ?? 0,
            delivery_date: product.delivery_deadline_date || null,
            store_id: detail.store_id,
            unit_price: detail.unit_price,
            section_id:detail.section_id,
            level_no: detail.level_no,
            item_service_type:detail?.item_service_type,
            start_date: detail.start_date || null,
            end_date: detail.end_date || null,
            send_price: detail.send_price ?? 0,
            sales_order_id:detail.sales_order_id,
            line_document_no:detail.line_document_no,
            product_service_no:detail.product_service_no,
            profit_cost_id:detail.profit_cost_id,
            discount_amount: detail.discount_amount || 0,
            incentive_amount: detail.incentive_amount || 0,
            net_adjustment_amount: this.getLineAdjustmentPrice(detail),
            remark: detail.remark || '',
            reverse_qty: detail.reverse_qty ?? null,
          }))
          : [];
        const combinedDetails = [...soDetails,...productDetails].filter(detail => Object.keys(detail).length > 0);
        return { details: combinedDetails };
      }),
    };

    console.log('Post Data:', postData);
    // return;
    if (this.data?.id) {
      this.apiService.updateGsn(this.data.id, postData).subscribe(
        (response) => {
          console.log('GSSN updated successfully:', response);
          if (response?.status === false) {
            alert(response.message || 'Failed to update GSSN.');
            return;
          }
          alert('GSSN Updated successfully.');
          if (this.is_reverse) {
            this.data.approval_status = 'Open';
            this.is_reverse = false;
          }
          if (exitAfterSave === 'close') {
            this.dialogRef.close({ id: this.data.id, action: 'update' });
          } else {
            this.enterViewMode();
          }
        },
        error => {
          console.error('Error updating GSN:', error);
           alert('Error updating GSSN. Please try again.');

        }
      );
    } else {
      this.apiService.createGsn(postData).subscribe(
        response => {
          console.log('GSSN created successfully:', response);
          if (response?.status === false) {
            alert(response.message || 'Failed to create GSSN.');
            return;
          }
          alert('GSSN Created successfully.');
          this.dialogRef.close({ id: response?.data?.id, action: 'create' });
        },
        error => {
          console.error('Error creating GSN:', error);
           alert('Error creating GSSN. Please try again.');

        }
      );
    }
  }


  // getCustomerBranch(CustomerId: number) {
  //   this.apiService.getBranch(CustomerId).subscribe(
  //     (response) => {
  //       this.selectedCustomerBranch = response.data;
  //       if (this.selectedCustomerBranchId) {
  //         this.customer_branch = this.selectedCustomerBranchId;
  //         console.log('customer branch',this.selectedCustomerBranchId)
  //       }
  //       console.log(this.selectedCustomerBranch);
  //     },
  //     (error) => {
  //       console.error("Error fetching branch data:", error);
  //     }
  //   );
  // }
  getCustomerBranch(
  customerId: number,
  params?: {
    offset?: number;
    limit?: number;
    search?: string;
    type?: string;
  }
) {
  if (!params) {
    this.apiService.getBranch(customerId).subscribe(
      (response: any) => {
        this.selectedCustomerBranch = response.data || response;
        if (this.selectedCustomerBranchId) {
          this.customer_branch = this.selectedCustomerBranchId;
        }
      },
      (error) => {
        console.error('Error fetching branch data:', error);
      }
    );
    return;
  }
  if (this.loadingBranch) return;
  this.loadingBranch = true;

  this.apiService.getBranch(customerId, params).subscribe(
    (response: any) => {
      const data = response.data || response || [];

      this.selectedCustomerBranch = [
        ...this.selectedCustomerBranch,
        ...data
      ];

      if (data.length < params.limit!) {
        this.branchHasMore = false;
      }

      this.branchOffset += data.length;
      this.loadingBranch = false;
    },
    () => (this.loadingBranch = false)
  );
}

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key;
    if ((charCode >= '0' && charCode <= '9') || charCode === '.') {
      return true;
    }
    event.preventDefault();
    return false;
  }
  // allowOnlyNumbers(event: KeyboardEvent, decimalLimit: number): boolean {
  //   const input = event.target as HTMLInputElement;
  //   const value = input.value;
  //   const key = event.key;
  //   if (key >= '0' && key <= '9') {
  //     if (value.includes('.')) {
  //       const decimals = value.split('.')[1];
  //       if (decimals && decimals.length >= decimalLimit) {
  //         event.preventDefault();
  //         return false;
  //       }
  //     }
  //     return true;
  //   }
  //   if (key === '.') {
  //     if (value.includes('.')) {
  //       event.preventDefault();
  //       return false;
  //     }
  //     return true;
  //   }
  //   event.preventDefault();
  //   return false;
  // }

  customerBranchDetails(id: any) {
    this.apiService.customerbranchdetails(id).subscribe(
      (response) => {
        this.customer_branch_details = response;
        console.log('customer_branch_details', this.customer_branch_details);
      },
      (error) => {
        console.error('Error fetching data:', error);
      }
    );
  }
  onSoChange(so_ids: number[]): void {
    const data = { sales_order_id: so_ids };

    this.apiService.getBranchBySo(data).subscribe(
      (response: any[]) => {
        this.branch_pc_data = response;
        console.log('branch_pc_data:', this.branch_pc_data);

        // After branch_pc_data is received, refresh all filters
        this.fetchbranch();
        if (this.data?.id) {
          this.fetchPcCc();
          this.fetchSection();
        } else {
          // Create: fetch fresh product list from SO
          this.fetchProductList();
        }
        // this.fetchPcCc();
        // this.filterSectionData();
      },
      (error) => {
        this.branch_pc_data = [];
        this.filteredBranchData = [];
        this.filteredPcCcData = [];
        this.filteredSectionData = [];
        console.error('Error fetching Sales Order related data:', error);
      }
    );
    if (!this.data?.id) {
      this.resetFields([
        'customer',
        'customer_branch',
        'so'
      ]);
    }
  }
  onProfitCostChange(): void {
    if (!this.data?.id) {
      this.resetFields([
        'customer',
        'customer_branch',
        'so',
        'branch_id',
        'profit_cost_id'
      ]);
    }
    this.fetchSection();
  }
  onBranchChange(): void {
    console.log('1234')
    this.fetchPcCc();
    if (!this.data?.id) {
      this.resetFields([
        'customer',
        'customer_branch',
        'so',
        'branch_id'
      ]);
    }
  }
  resetFields(excludedFields: string[] = []) {
    const defaultValues: any = {
      customer: null,
      customer_branch: null,
      so: [],
      branch_id: null,
      profit_cost_id: [],
      section_id: [],
      productList: [],

    };

    for (const key in defaultValues) {
      if (!excludedFields.includes(key)) {
        (this as any)[key] = defaultValues[key];
      }
    }
  }
  fetchbranch(): void {
    this.apiService.getDatabranch().subscribe(
      (response) => {
        this.branch_data = response;
        console.log('branch fetched:', this.branch_data);
        this.filterBranchData();
      },
      (error) => {
        console.error('Error fetching branches:', error);
      }
    );
  }

  filterBranchData(): void {
    if (this.branch_pc_data?.length > 0) {
      const branchIds = [...new Set(this.branch_pc_data.map(item => item.branch_id))];
      this.filteredBranchData = this.branch_data.filter(branch => branchIds.includes(branch.id));
      console.log('Filtered Branches:', this.filteredBranchData);
    } else {
      this.filteredBranchData = [];
      console.log('No branch_pc_data found, clearing branches');
    }
  }
  fetchPcCc(): void {
    this.apiService.getProfitCostCenter().subscribe(
      (response) => {
        this.profit_cost_data = response.data;
        console.log('Fetched profit/cost data:', this.profit_cost_data);
        this.filterPcCcData();
      },
      (error) => {
        console.error('Error fetching profit/cost data:', error);
      }
    );
  }

  filterPcCcData(): void {
    if (this.branch_pc_data?.length > 0) {
      const profitCostIds = [
        ...new Set(
          this.branch_pc_data.flatMap(item =>
            (item.profit_cost_id || []).map((id: string) => Number(id))
          )
        ),
      ];
      console.log('checking', this.profit_cost_data);
      this.filteredPcCcData = this.profit_cost_data.filter(pc => profitCostIds.includes(pc.id));
      console.log('Filtered PC/CC Data:', this.filteredPcCcData);
    } else {
      this.filteredPcCcData = [];
      console.log('No branch_pc_data found, clearing PC/CC');
    }
  }

  fetchSection(): void {
    this.apiService.getSection().subscribe(
      (response) => {
        this.section_data = response;
        console.log('section_data:', this.section_data);
        this.filterSectionData();
      },
      (error) => {
        console.error('Error fetching sections:', error);
      }
    );
  }

  filterSectionData(): void {
    if (this.branch_pc_data?.length > 0) {
      console.log(this.branch_pc_data,"branch_pc_data");
      const sectionIds = [
        ...new Set(
          this.branch_pc_data.flatMap(item =>
            (item.section_id || []).map((id: string) => Number(id))
          )
        ),
      ];
      
      let filtered = this.section_data.filter(section => sectionIds.includes(section.id));

      if (this.profit_cost_id && this.profit_cost_id.length > 0) {
        const selectedPcIds = this.profit_cost_id.map((id: any) => Number(id));
        filtered = filtered.filter(section => selectedPcIds.includes(Number(section.profit_cost_id)));
      }

      this.filteredSectionData = filtered;
      console.log('Filtered Sections:', this.filteredSectionData);
    } else {
      this.filteredSectionData = [];
      console.log('No branch_pc_data found, clearing sections');
    }
  }

  openGsnFileShowModal() {
    if (this.data.id) {
      this.apiService.getGsnFiles(this.data.id).subscribe(
        (response) => {
          this.image_data = response.uploadedFiles;
          console.log('GSN file data:', this.image_data);

          this.dialog.open(GsnFileComponent, {
            width: '1200px',
            height: '600px',
            data: {
              id: this.data.id,
              images: this.image_data
            }
          });
        },
        (error) => {
          console.error("Error fetching GSN files:", error);
        }
      );
    } else {
      console.error("Invalid GSN ID.");
    }
  }
  isImage(file: any): boolean {
    const filePath = file?.image || file?.name || '';
    return typeof filePath === 'string' && (
      filePath.toLowerCase().endsWith('.png') ||
      filePath.toLowerCase().endsWith('.jpg') ||
      filePath.toLowerCase().endsWith('.jpeg')
    );
  }
  isPDF(file: any): boolean {
    const filePath = file?.image || file?.name || '';
    return typeof filePath === 'string' && filePath.toLowerCase().endsWith('.pdf');
  }
  isPreviewable(extension: string): boolean {
    return ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'pdf'].includes(extension);
  }
  removeFile(index: number): void {
  if (index > -1 && index < this.uploadedFiles.length) {
    // Remove the file from the array
    this.uploadedFiles.splice(index, 1);
    this.uploadedFiles = [...this.uploadedFiles]; // trigger change detection
  }
}
onFileSelected(event: any): void {
  const files: FileList = event.target.files;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      let baseName = file.name;
      const dotIndex = baseName.lastIndexOf('.');
      let nameWithoutExt = dotIndex !== -1 ? baseName.substring(0, dotIndex) : baseName;
      const extension = dotIndex !== -1 ? baseName.substring(dotIndex) : '';
      let finalName = baseName;
      let counter = 1;

      // If the same name already exists, add suffix like name1, name2, etc.
      while (this.uploadedFiles.some(f => f.name === finalName)) {
        finalName = `${nameWithoutExt}${counter}${extension}`;
        counter++;
      }

      this.uploadedFiles.push({
        file: file,
        name: finalName,
        preview: e.target.result
      });
    };

    reader.readAsDataURL(file);
  }

  // Reset the input to allow selecting the same file again if needed
  event.target.value = '';
}


  getTotalPrice(send_qty: number, unit_price: number, detail: any) {
    const sendQty = Number(send_qty) || 0;
    const unitPrice = Number(unit_price) || 0;
    console.log('send_qty:', sendQty);
    console.log('unit_price:', unitPrice);
    // detail.gsn_total_price = (sendQty * unitPrice).toFixed(2);
    // detail.send_price = (sendQty * unitPrice).toFixed(2);
    const formattedQty = Number(sendQty.toFixed(3));
    const total = formattedQty * unitPrice;
    
    detail.send_qty = formattedQty;
    detail.gsn_total_price = Number(total.toFixed(2));
    detail.send_price = Number(total.toFixed(2));
    detail.actual_qty = sendQty;
    detail.net_adjustment_amount = this.getLineAdjustmentPrice(detail);
    this.updateGrandTotal();
  }
  getSentQty(total_price: number, unit_price: number, detail: any) {
    const sendPrice = Number(total_price) || 0;
    const unitPrice = Number(unit_price) || 0;
    
    console.log('send_price:', sendPrice);
    console.log('unit_price:', unitPrice);
    // detail.send_qty = (sendPrice / unitPrice).toFixed(3);
    const formattedPrice = Number(sendPrice.toFixed(2));
    const qty = unitPrice ? formattedPrice / unitPrice : 0;
    
    detail.gsn_total_price = formattedPrice;
    detail.send_qty = Number(qty.toFixed(3));
    detail.send_price = formattedPrice;
    detail.actual_qty = qty;
    detail.net_adjustment_amount = this.getLineAdjustmentPrice(detail);
    this.updateGrandTotal();
  }

  getLineAdjustmentPrice(detail: any): number {
    const base = (Number(detail.actual_qty || detail.send_qty) || 0) * (Number(detail.unit_price) || 0);
    const discount = Number(detail.discount_amount) || 0;
    const incentive = Number(detail.incentive_amount) || 0;
    return base - discount + incentive;
  }


  onDiscountIncentiveChange(detail: any) {
    detail.net_adjustment_amount = this.getLineAdjustmentPrice(detail);
    this.getTotalPrice(detail.actual_qty || detail.send_qty, detail.unit_price, detail);
  }
    validateDiscountAmount(detail: any, totalPriceField: string): void {
    const discount = Number(detail.discount_amount) || 0;
    const totalPrice = Number(detail[totalPriceField]) || 0;
    if (discount > totalPrice) {
      alert('Discount Amount cannot exceed Total Price (' + totalPrice.toFixed(2) + ')!');
      detail.discount_amount = '';
      this.onDiscountIncentiveChange(detail);
    }
  }
  // 👇 ADD THIS NEW METHOD HERE 👇
validateSendQty(detail: any): void {
  if (detail.send_qty < 0) {
    alert('❌ Negative quantity not allowed!');
    detail.send_qty = '';
  }
}
  getGreaterAdjustmentType(): number | null {
    const totalD = this.getTotalDiscountAmount();
    const totalI = this.getTotalIncentiveAmount();
    if (totalD === totalI) return null;
    return totalD > totalI ? 1 : 2;
  }

  getFinalHeaderAmount(): number {
    const totalD = this.getTotalDiscountAmount();
    const totalI = this.getTotalIncentiveAmount();
    return Math.abs(totalD - totalI);
  }

  onLumpsumChange() {
    this.updateGrandTotal();
  }

  limitDecimal(event: any, decimalLimit: number) {
    const input = event.target;
    let value = input.value;
    if (!value) return;
    const start = input.selectionStart;
    const end = input.selectionEnd;
    const parts = value.split('.');
    parts[0] = parts[0].replace(/[^0-9]/g, '');
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/[^0-9]/g, '').substring(0, decimalLimit);
      if (parts[1].length > decimalLimit) {
        alert(`Only ${decimalLimit} digits allowed after decimal`);
        parts[1] = parts[1].substring(0, decimalLimit);
      }
      value = parts[0] + '.' + parts[1];
    } else {
      value = parts[0];
    }
    input.value = value;
    setTimeout(() => {
      input.setSelectionRange(start, end);
    });
  }


  updateGrandTotal() {
    this.grandTotal = this.getGrandTotal();
  }

  getGrandTotal(): number {
    if (!this.productList) return 0;
    let total = 0;
    this.productList.forEach(product => {
      const details = product.so_details || product.details || [];
      total += details.reduce((sum, d) => {
        const qty = Number(d.actual_qty || d.send_qty) || 0;
        const unitPrice = Number(d.unit_price) || 0;
        return sum + (qty * unitPrice);
      }, 0);
    });
    return total;
  }

  getDiscountedTotal(): number {
    if (!this.productList) return 0;
    let total = 0;
    this.productList.forEach(product => {
      const details = product.so_details || product.details || [];
      total += details.reduce((sum, d) => sum + this.getLineAdjustmentPrice(d), 0);
    });
    return total;
  }

  getNetAdjustment(): number {
    return Math.abs(this.getGrandTotal() - this.getDiscountedTotal());
  }

  getTotalDiscountAmount(): number {
    let total = 0;
    this.productList?.forEach(product => {
      const details = product.so_details || product.details || [];
      total += details.reduce((sum, d) => sum + (parseFloat(d.discount_amount) || 0), 0);
    });
    return total;
  }

  getTotalIncentiveAmount(): number {
    let total = 0;
    this.productList?.forEach(product => {
      const details = product.so_details || product.details || [];
      total += details.reduce((sum, d) => sum + (parseFloat(d.incentive_amount) || 0), 0);
    });
    return total;
  }

  sendForApprove() {
      if (!confirm('Do you want to send this document for approval?')) {
      return;
    }
    const profit_cost_ids = this.data.profit_cost_id;
    const profit_cost_id = profit_cost_ids?.toString().split(',')[0];
    const requestData = {
      document_type: 'Gsn',
      document_id: this.data.id,
      profit_cost_id: profit_cost_id
    };
    this.apiService.sendForApproval(requestData).subscribe(
      (response) => {
        console.log('Sales Order sent for approval:', response);
    
         alert(response?.message || 'Document sent for approval successfully'); 
         this.dialogRef.close({ data: this.data.id, action: 'approvalsend' });
       
      },
      (error) => {
        console.error('Error sending sales order for approval:', error);
        alert('Error sending sales order for approval: ' + error.error.message);
      }
    );
  }

  showApprovalTimeline() {
    const requestData = {
      document_type: 'Gsn',
      document_id: this.data.id,
    };

    this.apiService.getApprovalTimeline(requestData).subscribe(
      (response) => {
        console.log('Approval timeline data:', response);
        
        // Open approval timeline dialog with real data
        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: response.data || response }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      },
      (error) => {
        console.error('Error fetching approval timeline:', error);
        
        // Fallback to demo data if API fails
        const demoApprovalData: ApprovalTimelineData = {
          document_id: this.data.id || 12345,
          document_type: 'Gsn',
          current_stage: 2,
          total_stages: 4,
          overall_status: 'pending',
          created_at: new Date().toISOString(),
          created_by: 'Current User',
          stages: [
            {
              id: 1,
              name: 'Department Head Review',
              level: 1,
              status: 'approved',
              approver_name: 'Sarah Johnson',
              approved_at: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
              comments: 'All requirements met, approved for next level',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 2,
              name: 'Finance Manager Review',
              level: 2,
              status: 'pending',
              is_current: true,
              timeline: [],
              pending_time_seconds: 7200,
              pending_time_formatted: '2h 0m 0s',
              cancellation_count: 0
            },
            {
              id: 3,
              name: 'General Manager Approval',
              level: 3,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            },
            {
              id: 4,
              name: 'Final Approval',
              level: 4,
              status: 'not_started',
              timeline: [],
              pending_time_seconds: 0,
              pending_time_formatted: '0s',
              cancellation_count: 0
            }
          ]
        };

        const dialogRef = this.dialog.open(ApprovalTimelineDialogComponent, {
          width: '800px',
          height: '600px',
          disableClose: true,
          data: { approvalData: demoApprovalData }
        });

        dialogRef.afterClosed().subscribe(result => {
          console.log('Approval timeline dialog closed:', result);
        });
      }
    );
  }

  viewRelatedDocuments(salesOrderId: number): void {
    const payload = {
      document_id: salesOrderId,
      document_type: "gsn"
    };

    // Show loading state
    const loadingDialog = this.dialog.open(DocumentTracingModalComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '80%',
      maxHeight: '800px',
      disableClose: false,
      data: {
        tracingData: null,
        loading: true
      }
    });

    this.apiService.getDocumentTracing(payload).subscribe(
      (response) => {
        if (response.status) {
          // Close loading dialog and open with data
          loadingDialog.close();

          const dialogRef = this.dialog.open(DocumentTracingModalComponent, {
            width: '90%',
            maxWidth: '1200px',
            height: '80%',
            maxHeight: '800px',
            disableClose: false,
            data: {
              tracingData: {
                ...response.data,
                document_type: "gsn",
                current_document: response.data.current_document || `SO${salesOrderId}` // Ensure current document is set
              },
              loading: false
            }
          });

          dialogRef.afterClosed().subscribe(() => {
            console.log('Document tracing modal closed');
          });
        } else {
          loadingDialog.close();
          alert('Error: ' + response.message);
        }
      },
      (error) => {
        loadingDialog.close();
        console.error('Error fetching document tracing:', error);

        let errorMessage = 'Error fetching related documents. Please try again.';
        if (error.error && error.error.message) {
          errorMessage = error.error.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        alert(errorMessage);
      }
    );
  }
  onCustomerOpen(opened: boolean) {
  if (!opened) return;
  this.customerdata = [];
  this.customerOffset = 0;
  this.customerHasMore = true;
  this.customerSearch = '';

  this.customerData({
    offset: this.customerOffset,
    limit: this.customerLimit,
    search: this.customerSearch,
    type: "lazyloading"
  });
  Promise.resolve().then(() => {
    const panel = document.querySelector(
      '.customer-select-panel'
    ) as HTMLElement;

    if (!panel) return;
    panel.addEventListener('scroll', this.onCustomerScroll);
  });
}

onCustomerScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.customerHasMore &&
    !this.loadingCustomer
  ) {
    this.customerData({
      offset: this.customerOffset,
      limit: this.customerLimit,
      search: this.customerSearch,
      type: "lazyloading"
    });
  }
};

onCustomerSearch(value: string) {
  this.customerSearch = value || '';
  this.customerdata = [];
  this.customerOffset = 0;
  this.customerHasMore = true;

  this.customerData({
    offset: this.customerOffset,
    limit: this.customerLimit,
    search: this.customerSearch,
    type: "lazyloading"
  });
}
onBranchOpen(opened: boolean) {
  if (!opened) return;
  if (!this.customer) return;

  this.selectedCustomerBranch = [];
  this.branchOffset = 0;
  this.branchHasMore = true;
  this.branchSearch = '';

  this.getCustomerBranch(this.customer, {
    offset: this.branchOffset,
    limit: this.branchLimit,
    type: 'lazyloading'
  });

  Promise.resolve().then(() => {
    const panel = this.branchSelect.panel?.nativeElement;
    if (!panel) return;

    panel.removeEventListener('scroll', this.onBranchScroll);
    panel.addEventListener('scroll', this.onBranchScroll);
  });
}
onBranchScroll = (event: any) => {
  const panel = event.target as HTMLElement;

  if (
    panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 20 &&
    this.branchHasMore &&
    !this.loadingBranch
  ) {
    this.getCustomerBranch(this.customer, {
      offset: this.branchOffset,
      limit: this.branchLimit,
      search: this.branchSearch,
      type: 'lazyloading'
    });
  }
};
onBranchSearch(value: string) {
  this.branchSearch = value || '';

  this.selectedCustomerBranch = [];
  this.branchOffset = 0;
  this.branchHasMore = true;

  this.getCustomerBranch(this.customer, {
    offset: this.branchOffset,
    limit: this.branchLimit,
    search: this.branchSearch,
    type: 'lazyloading'
  });
}
  getInitialTotal(detail: any) {
    if (!detail.initial_total_qty) {
      detail.initial_total_qty = this.parseNumber(detail.gsn_remaining_qty) + this.parseNumber(detail.send_qty);
    }
    return detail.initial_total_qty;
  }

  onReverseQtyChange(detail: any): void {
    const reverse = Number(detail.reverse_qty) || 0;
    const sendQty = detail.send_qty;
    const remainQty=detail.remaining_qty;
    
    if (reverse>remainQty) {
      alert('Reverse quantity cannot be more than remain quantity!');
      detail.reverse_qty = 0;
      return;
    }

    detail.send_qty = sendQty-reverse;
    //detail.actual_qty = newSendQty; // Important: payload uses actual_qty!
    console.log('Reverse:', reverse, 'Send Qty:', detail.send_qty, 'Actual Qty:', detail.actual_qty);
  }
 getCustomerName(customerId: number | null): string {
  if (!customerId) return 'No customer selected';

  const customer = this.customerdata?.find(
    c => c.customer_id === customerId
  );
  return customer ? customer.customer_name : 'Unknown Customer';
}

getcustomerBranchName(branchId: number | null): string {
  if (!branchId) return 'No branch selected';

  const branch = this.selectedCustomerBranch?.find(
    b => b.id === branchId
  );

  return branch ? branch.branch_name : 'Unknown Branch';
}
getSoName(soId: number | null): string {
  if (!soId) return 'No SO selected';
  const so = this.so_data?.find(
    s => s.id === soId
  );
  return so ? so.so_no : 'Unknown SO';
}
getBranchName(branchId: number | null): string {
  if (!branchId) return 'No branch selected';

  const branch = this.filteredBranchData?.find(b => b.id === branchId);
  return branch ? branch.name : 'Unknown branch';
}
getPcCcName(pcCcIds: number[] | null): string {
  if (!pcCcIds || pcCcIds.length === 0) {
    return 'No PC/CC selected';
  }
  const names = this.filteredPcCcData
    ?.filter(pc => pcCcIds.includes(pc.id))
    .map(pc => pc.name);

  return names && names.length ? names.join(', ') : 'Unknown PC/CC';
}
getSectionName(sectionId: number[] | null): string {
  if (!sectionId) return 'No section selected';
  // const section = this.filteredSectionData?.find(s => s.id === sectionId);
  // return section ? section.section_name : 'Unknown section';
     const section = this.filteredSectionData
    ?.filter(pc => sectionId.includes(pc.id))
    .map(pc => pc.section_name);

  return section && section.length ? section.join(', ') : 'Unknown section';
}

  hasDetailAdjustments(): boolean {
    return this.productList?.some(p => {
      const ds = p.so_details || p.details || [];
      return ds.some((d: any) => (d.discount_amount > 0 || d.incentive_amount > 0));
    }) || false;
  }
}